import("./bootstrap");

// import('http://localhost:20000/remoteEntry.js').then(() => {
//   import('./bootstrap')
// })
